import axios from 'axios';

export default {
    add(context, data) {
        var options = {
            url: window.apiUrl + '/file',
            method: 'POST',
            data:data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    protect(type, record, file) {
        const data = {
            type: type,
            record: record,
            file: file
        }

        const options = {
            method: 'POST',
            url: window.apiUrl + '/protect',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },

    download(file, type, assetId, browserId, source) { 
        const data = {
            file: file,
            type: type,
            assetId: assetId,
            browserId: browserId
        }  
        
        if (source) data.source = true;
        
        let url = window.apiUrl;

        // james dev setup
        if (window.location.href.includes('localhost') && url.includes('https') && url.includes('ubuntu')) url = url.replace('https','http');
        
        const options = {
            method: 'POST',
            url: url + '/download',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    deleteWatermarked(file, type, assetId) {
        const data = {
            file: file,
            type: type,
            assetId: assetId
        }

        const options = {
            method: 'DELETE',
            url: window.apiUrl + '/watermark',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });

    },
    delete(context, file) {
        var options = {
            url: window.apiUrl + '/file/' + file.id,
            method: 'DELETE',
            data: file,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    get(context, query) {
        var url = window.apiUrl + '/files/';
        console.log(query);
        if (query.instanceId) {
            url += query.instanceId ;
        }
        if (query.week) {
            url += '/' + query.week
        }

        if (query.upToWeek) {
            url += '?up_to_week=' + query.upToWeek
        }
        console.log(query);
        var options = {
            url: url,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getWatermarkedFiles() {
        var options = {
            url: window.apiUrl + '/watermarked-files',
            method: 'GET',            
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },

};



// WEBPACK FOOTER //
// ./src/services/files/index.js